export default {
  modelName: 'risk_template',
  versionModelName: 'risk_template_version',
  versionTimestampKey: 'created_at',
  label: '風險評估',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    // is_active: {
    //   type: 'switch',
    //   label: '顯示/隱藏',
    //   defaultValue: true,
    //   activeText: '顯示',
    //   inactiveText: '隱藏',
    // },
    last_version: {
      type: 'last_version',
      // label: '風險評估資訊',
      modelName: 'risk_template_version',
      showFields: ['name_mainlocale', 'updated_at'],
      fields: {
        locales: {
          type: 'locales',
          // label: "多語言內容",
          fields: {
            name: {
              type: 'textarea',
              label: '風險評估名稱',
              rules: 'required',
              maxlength: 1000,
            },
            // remark: {
            //   type: 'text',
            //   label: '備註',
            //   maxlength: 1000,
            // },
          },
        },
        updated_admin: {
          type: 'belongsTo',
          label: '最後更新人',
          textKey: 'name',
          readonly: true,
        },
        updated_at: {
          type: 'datetime',
          label: '更新時間',
          readonly: true,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    area: {
      label: '適用地區',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'area',
      rules: 'required',
      placeholder: '選擇地區',
      clearable: true,
    },
    area_section: {
      label: '適用子地區',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'area_section',
      placeholder: '選擇子地區',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    system_class: {
      label: '選擇領域',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'system_class',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    system_subclass: {
      conditionKeys: [
        {
          fieldName: 'system_class',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_class',
      label: '選擇子領域',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'system_subclass',
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
  },
};
